import { Injectable } from '@angular/core';
import { loadScriptByUrl } from '@src/utils';
import { environment } from '@src/environments/environment';
import { APP_CONFIG } from '@src/core';

import { TELEGRAM_WEB_APP_CONFIG } from '../constants';

/**
 * Веб сервис Telegram
 *
 * @see https://core.telegram.org/bots/webapps#initializing-mini-apps
 */
@Injectable({
  providedIn: 'root',
})
export class TelegramWebAppService {
  private initData?: string;

  private tgWebApp!: WebApp;

  constructor() {
    loadScriptByUrl(TELEGRAM_WEB_APP_CONFIG.scriptUrl).then(() => {
      this.tgWebApp = window.Telegram?.WebApp;

      if (environment.emulateBotEnv?.enabled) {
        this.initData = environment.emulateBotEnv.key;
      } else {
        this.initData = this.tgWebApp?.initData;
      }
    });
  }

  isRunAsTelegramWebApp() {
    return !!this.initData || environment.emulateBotEnv?.enabled;
  }

  getData() {
    return this.initData;
  }

  openLink(url: string, baseUrl: boolean = false) {
    window.open(baseUrl ? `${APP_CONFIG.baseUrl}/${url}` : url, '_blank');
  }

  openTelegramLink(url: string, baseUrl: boolean = false) {
    this.tgWebApp.openTelegramLink(baseUrl ? `${TELEGRAM_WEB_APP_CONFIG.baseUrl}/${url}` : url);
  }

  close() {
    this.tgWebApp.close();
  }
}
